module.exports = __webpack_public_path__ + "static/media/Multigrain Bread.0c8848b4.jpg";